module.exports = {
      id: "icon-election-usage",
      viewBox: "0 0 110 110",
      url: "/" + "sprite-5d017f3fe034ec5d98a70bae909b913a.svg#icon-election",
      toString: function () {
        return this.url;
      }
    }